import { CheckBox, DatePicker, Icon, TextBox } from '../../../share/Elements'
import Card from '../../../share/Components/Card/Card'
import { TextBoxTypeEnum } from '../../../enums/TextBoxTypeEnum'
import { useState } from 'react'
import {
  measureItemType,
  MeasureUnitDto,
} from '../../../models/ViewModels/RecordCatalogViewModel'
import {
  CheckupType,
  RecordCheckupType,
} from '../../../models/ViewModels/RecordViewModel'
import { UUID } from 'crypto'

type Dates = {
  fromDate: string
  toDate: string
}
const RecordCheckup = ({
  catalog,
  item,
  onItemChange,
}: {
  catalog?: Array<measureItemType>
  item?: RecordCheckupType
  onItemChange?: (updatedItem: RecordCheckupType) => void // A function to handle item changes
}) => {
  const [date, setDate] = useState<string>(new Date().toISOString())
  const [time, setTime] = useState<string>(new Date().getFormattedTime())

  const handleServeClick = (data: { id: number; value: number }) => {
    // Update the parent component's state or perform any other actions
    // Step 1: Retrieve the current items array

    const currentItems = item?.items || []
    const itemCheckup: CheckupType = {
      measureId: data.id,
      value: data.value,
      date: date,
      unitId: getUnitIdFromMeasureId(data.id, catalog),
      unit: getUnitFromMeasureId(data.id, catalog),
      name: getNameFromMeasureId(data.id, catalog),
      time: time,
    }

    // Step 2: Add the new item to the items array
    const updatedItems = [...currentItems, itemCheckup]

    // Step 3: Create a new RecordCheckupType with the updated items array
    const checkupData: RecordCheckupType = {
      ...item,
      items: updatedItems,
    }

    // Call the callback function to pass data to the parent component
    onItemChange && onItemChange(checkupData)
    setTime(new Date().getFormattedTime())
  }
  const getUnitIdFromMeasureId = (
    measureId: number,
    items?: measureItemType[]
  ) => {
    const matchingItem = items?.find((item) =>
      item.unit.some((unit) => unit.measureId === measureId)
    )

    return matchingItem ? matchingItem.unit[0].unitId || 0 : 0
  }
  const getUnitFromMeasureId = (
    measureId: number,
    items?: measureItemType[]
  ) => {
    const matchingItem = items?.find((item) =>
      item.unit.some((unit) => unit.measureId === measureId)
    )

    return matchingItem ? matchingItem.unit[0].unitText || '' : ''
  }
  const getNameFromMeasureId = (
    measureId: number,
    items?: measureItemType[]
  ) => {
    const matchingItem = items?.find((item) =>
      item.unit.some((unit) => unit.measureId === measureId)
    )

    return matchingItem ? matchingItem.name || '' : ''
  }
  const handleAbstractClick = (index: number) => {
    const updatedItems = [...(item?.items || [])]
    updatedItems[index] = {
      ...updatedItems[index],
      showAbstract: !updatedItems[index].showAbstract,
    }

    const data: RecordCheckupType = {
      ...item,
      items: updatedItems,
    }
    onItemChange && onItemChange(data)
  }

  const handleDeleteClick = (index: number) => {
    const updatedItems = [...(item?.items || [])]
    updatedItems.splice(index, 1)

    const updatedObject = { ...item, items: updatedItems }

    onItemChange && onItemChange(updatedObject)
  }
  const handleToDateChange = (e) => {
    // Assuming you have a way to get the raytebValue

    const dateInput = document.getElementById('date')
    const raytebValue = dateInput?.getAttribute('rayteb-value')
    const newToDate = new Date(raytebValue!)
    setDate(raytebValue!)
  }
  return (
    <>
      <div className='p-6'>
        <div className='grid grid-cols-2 gap-3'>
          <DatePicker
            raytebValue={date}
            value={new Date(date).toShamsi()}
            innerText='تاریخ'
            id='date'
            className='h-9'
            onChange={handleToDateChange}
          />
          <TextBox
            className='w-full h-9'
            Regular='^(([01]?[0-9]|2[0-3]):[0-5][0-9]){1,5}$'
            RxgMessage='از 00:00 تا 23:59'
            innerText='ساعت'
            isRequired={false}
            Type={TextBoxTypeEnum.Time}
            value={time}
            onChange={(e) => {
              setTime(e.target.value)
            }}
          />
        </div>
        <div className='flex justify-center imtes-center flex-col mt-9 gap-4'>
          {catalog?.map((n, i) => (
            <Serve
              key={i}
              title={n.name!}
              amount={n.unit[0]?.unitText!}
              id={n.id!}
              onServeClick={handleServeClick}
            />
          ))}
        </div>

        <div className='mt-5 grid grid-cols-1 gap-1 '>
          {item?.items?.length! > 0
            ? item?.items?.map((n, i) => (
              <Card
                key={i}
                text={n.name}
                footer={
                  <CardFooter
                    isAbstract={n.showAbstract}
                    onAbstractClick={() => handleAbstractClick(i)}
                    onDeleteClick={() => handleDeleteClick(i)}
                  />
                }
              >
                <span className='text-[9px] text-primaryLight ml-1  font-bold'>
                  {`${n.unit} ${n.value}`}
                </span>
                <br />
                <span className='text-xs text-primaryLight ml-1 font-bold'>
                  {new Date(n.date!).toShamsi().toPersian()} -{' '}
                  {n.time?.toPersian()} -
                </span>
              </Card>
            ))
            : null}
        </div>
      </div>
    </>
  )
}
const Serve = ({
  title,
  amount,
  id,
  onServeClick,
}: {
  title: string
  amount: string
  id: number
  onServeClick?: (data: { id: number; value: number }) => void
}) => {
  const [textBoxValue, setTextBoxValue] = useState('')

  const handleTextBoxChange = (newValue: string) => {
    setTextBoxValue(newValue)
  }

  const handleServeIconClick = () => {
    // Convert the value to a number if needed
    const numericAmount = parseFloat(textBoxValue)

    // Check if the conversion was successful
    if (!isNaN(numericAmount)) {
      onServeClick && onServeClick({ id, value: numericAmount })
    }
    setTextBoxValue('')
  }

  return (
    <>
      <div className='grid  grid-cols-9 justify-items-end  items-center'>
        <Icon
          icon='rayteb-add-circular'
          className='text-xl col-span-1 text-primaryLight w-full !justify-start'
          onClick={handleServeIconClick}
        />
        <div className='col-span-3'>
          <TextBox
            isRequired={false}
            innerText={amount}
            debounceTime={0}
            className='!border-0 !border-b  !focus:border-none !focus:border-b 
               border-primaryLight focus:ring-0 rounded-none bg-primaryDefault !w-full h-7 !text-xs'
            Type={TextBoxTypeEnum.Text}
            value={textBoxValue}
            onChange={(e) => handleTextBoxChange(e.target.value)}
          />
        </div>
        <label className='text-xs font-bold text-end col-span-5'>{title}</label>
      </div>
    </>
  )
}

const CardFooter = ({
  isAbstract,
  onAbstractClick,
  onDeleteClick,
}: {
  isAbstract?: boolean
  onAbstractClick: () => void
  onDeleteClick: () => void
}) => (
  <>
    <div className='w-full flex justify-end items-center pt-3'>
      <div className='flex justify-center itmes-center gap-2'>
        <Icon
          icon='rayteb-medical-ophthalmology'
          className={`text-xl  ${isAbstract ? 'text-primary' : 'text-disable'}`}
          onClick={onAbstractClick}
        />
        <Icon
          icon='rayteb-delete'
          className='text-xl text-primary'
          onClick={onDeleteClick}
        />
      </div>
    </div>
  </>
)
export default RecordCheckup
